import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ClothingCatalogItemList,
  ClothingPersonalNorm,
  ClothingUserOption
} from '../../../models/clothing.model';

interface ClothingCatalogNameIndex {
  [catalogItemId: string]: string;
}

interface ClothingPersonalNormDraft {
  userId: string;
  catalogItemId: string;
  quantity: number;
}

@Component({
  selector: 'app-clothing-admin-personal-norms',
  templateUrl: './clothing-admin-personal-norms.component.html',
  styleUrls: ['./clothing-admin-personal-norms.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClothingAdminPersonalNormsComponent {
  @Input() hideHeader = false;
  @Input() users: ClothingUserOption[] = [];
  @Input() catalogItems: ClothingCatalogItemList[] = [];
  @Input() selectedUserId = '';
  @Input() draftNorm: ClothingPersonalNormDraft;
  @Input() norms: ClothingPersonalNorm[] = [];
  @Input() catalogNameIndex: ClothingCatalogNameIndex = {};
  @Input() isLoading = false;
  @Input() isSaving = false;
  @Output() selectUser = new EventEmitter<string>();
  @Output() createNorm = new EventEmitter<void>();
  @Output() saveNorm = new EventEmitter<ClothingPersonalNorm>();
  @Output() deleteNorm = new EventEmitter<string>();

  changeUser(userId: string) {
    this.selectUser.emit(userId);
  }

  submitCreate() {
    this.createNorm.emit();
  }

  submitSave(norm: ClothingPersonalNorm) {
    this.saveNorm.emit(norm);
  }

  submitDelete(normId: string) {
    this.deleteNorm.emit(normId);
  }

  resolveCatalogName(catalogItemId: string): string {
    return this.catalogNameIndex[catalogItemId] || catalogItemId;
  }

  trackByUser(index: number, user: ClothingUserOption): string {
    return user.id;
  }

  trackByCatalog(index: number, item: ClothingCatalogItemList): string {
    return item.id;
  }

  trackByNorm(index: number, norm: ClothingPersonalNorm): string {
    return norm.id;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/clothing/clothing-admin-personal-norms.component.ts